import { Box, Button, Modal, Typography } from "@mui/material";

import Grain from "../../assets/images/grain.png";
import { Trash2 } from "lucide-react";
import { useNursingFunctionsContext } from "../../components/NursingFunctions/NursingFunctionsProvider";
import { useConfirmDeleteModal } from "./useConfirmDeleteModal";

export default function ConfirmDeleteModal({
	open,
	onClose,
}: {
	open: boolean;
	onClose: () => void;
}) {
	const { isLoading, onDeleteAssignedFunctions } = useConfirmDeleteModal();
	const { selectedRows, reloadInformation } = useNursingFunctionsContext();

	return (
		<Modal
			open={open}
			className="modal-container"
		>
			<Box className="modal modal--small">
				<Box
					sx={{
						display: isLoading ? "flex" : "none",
					}}
				>
					<Box className="custom-loader__background" />
					<Box className="custom-loader" />
				</Box>
				<Box className="modal__header">
					<img
						className="modal__header__grain"
						src={Grain}
					/>
					<Trash2 className="modal__header__icon" />
					<Box>
						<Typography className="modal__header__title">Dar de baja</Typography>
					</Box>
				</Box>
				<Box className="modal__body">
					<Box display={"flex"}>
						<Typography className="modal__body__paragraph">
							¿Desea eliminar al profesional de funciones de enfermería?
						</Typography>
					</Box>
				</Box>
				<Box
					className="modal__buttons"
					justifyContent={"center"}
				>
					<Button
						className="modal__buttons--close"
						style={{
							width: "100%",
						}}
						onClick={() => onClose()}
					>
						Cancelar
					</Button>
					<Button
						className="modal__buttons--delete"
						startIcon={<Trash2 />}
						style={{
							width: "100%",
						}}
						onClick={async () => {
							await onDeleteAssignedFunctions([...selectedRows]);
							onClose();
							reloadInformation();
						}}
					>
						Dar de baja
					</Button>
				</Box>
			</Box>
		</Modal>
	);
}
